<p-messages [(value)]="msgs"></p-messages>
<div class="p-grid">
    <div class="col-12 p-md-12 p-lg-12" *ngIf="cargandoDataInit">
        <div class="card">
            <h4>{{ appConfig.ux.loadingMsg }}</h4>
            <p-progressBar mode="indeterminate"></p-progressBar>
        </div>
    </div>
    <div class="col-12 p-md-12 p-lg-12" *ngIf="!cargandoDataInit">
        <div class="card p-p-4">
            <div class="flex align-items-center justify-content-between"> 
                <button pButton pRipple
                        type="button" 
                        pTooltip="{{ appConfig.ux.actions.add }}" tooltipPosition="bottom"
                        icon="pi pi-plus" class="p-button-rounded p-button-secondary p-button-sm ml-1"
                        (click)="nuevoServicio()">
                </button>
                <span class="p-input-icon-left w-full">
                    <i class="pi pi-search"></i>
                    <input
                        pInputText
                        type="text"
                        (input)="filteredProductByKeyword($event);"
                        placeholder="{{appConfig.ux.searchMsg}}"
                        class="w-full"/>
                </span>
            </div>
            <p-table
                #dt
                [value]="servicios"
                [columns]="cols"
                dataKey="id"
                selectionMode="multiple"
                [(selection)]="serviciosSeleccionados"
                [rowHover]="true"
                [rows]="rows"
                [paginator]="false" 
                [scrollable]="true"
                scrollHeight="600px"    
                [filterDelay]="0"
                sortMode="multiple"
                [multiSortMeta]="multiSortMeta"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} entradas"
                styleClass="p-datatable-striped">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                    <th style="width: 3rem">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th
                        *ngFor="let col of columns"
                        [pSortableColumn]="col.field"
                        [hidden]="!col.visible"
                        [ngClass]="col.class">
                        <div class="p-d-flex p-jc-between p-ai-center">
                            {{ col.header }}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </div>
                    </th>
                    <th style="width: 6rem">Acciones</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr>
                        <td style="width: 3rem">
                            <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                        </td>
                        <td *ngFor="let col of columns" [hidden]="!col.visible" [ngClass]="col.class">
                            <span> {{ rowData[col.field] }}</span>
                        </td>
                        <td>
                            <p-button
                                pTooltip="{{ appConfig.ux.actions.actions }}"
                                tooltipPosition="bottom"
                                styleClass="p-button-rounded p-button-text p-button-sm"
                                (click)="presentarOpcionesActionSheet($event, rowData); op.toggle($event)">
                                <ng-template pTemplate="content"><img alt="acciones" src="assets/layout/icons/tap.png" style="width: 2rem" />
                                </ng-template>
                            </p-button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
            <p-paginator
                (onPageChange)="handlePagination($event)"
                [rows]="rows"
                [totalRecords]="totalRecords">
            </p-paginator>  
        </div>
    </div>
</div>
<!--------------------------------------->
<!------Diálogos de funcionalidades------>
<!--------------------------------------->
<!---Diálogo de acciones--->
<p-overlayPanel #op 
                [style]="{ width: '15vw' }"
                [showCloseIcon]="false">
    <ng-template pTemplate>
        <div class="p-fluid p-formgrid p-grid">
            <button
                *ngFor="let item of buttonsActions; let i = index"
                pButton
                type="button"
                [label]="item.text"
                [icon]="item.icon"
                [class]="item.cssClass"
                (click)="ejecutarAccion($event, item.action, item.data); op.hide($event)"
                [disabled]="item.disabled"></button>
        </div>
    </ng-template>
</p-overlayPanel>
<!---------------------------------------------->
<!------Ventanas de confirmaciones modales------>
<!---------------------------------------------->
<p-confirmDialog #cd header="Confirmación" icon="pi pi-exclamation-triangle">
    <ng-template pTemplate="footer">
        <button
            pButton
            type="button"
            label="No"
            icon="pi pi-times"
            class="p-button-secondary"
            (click)="cd.reject()"></button>
        <button pButton type="button" label="Sí" icon="pi pi-check" class="p-ml-2" (click)="cd.accept()"></button>
    </ng-template>
</p-confirmDialog>
<!--Ventana de espera de procesamiento-->
<p-dialog
    [(visible)]="procesando"
    modal="modal"
    showEffect="fade"
    [breakpoints]="{ '960px': '90vw', '640px': '100vw' }"
    [style]="{ width: '90vw' }"
    (onHide)="procesando = false">
    <ng-template pTemplate="header">
        <h4>{{ appConfig.ux.loadingMsg }}</h4>
    </ng-template>
    <ng-template pTemplate="content">
        <p-progressBar mode="indeterminate"></p-progressBar>
    </ng-template>
    <ng-template pTemplate="footer">
        <span class="p-text-uppercase">{{ appConfig.app.name }}</span>
    </ng-template>
</p-dialog>

<app-producto [mostrarEditor] = "mostrarEditor" 
              [producto] ="producto"
              [estaCargandoDatos] = "false"
              (productoGuardado) = "handleProductoGuardado($event);"></app-producto>
